export default __webpack_public_path__ + "static/media/view_img2.62e1411f.png";